import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.yendo.mx.App
import com.yendo.mx.utils.inicializarFirebaseWeb
import kotlinx.browser.document
import kotlinx.browser.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    window.onload = {
        inicializarFirebaseWeb()

        val root = document.getElementById("root") ?: document.body ?: error("No root element")
        ComposeViewport(root) {
            App()
        }
    }
}
